// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030340/js/" + chunkId + "." + {"44":"29208229","225":"2868a762","481":"3c1eda3f","486":"3ddf7416","770":"57b642f5"}[chunkId] + ".0.6094445930948824.chunk.js";
};